import * as React from 'react';
import styles from '../styles.module.scss';

interface Option {
    text: string;
    value: string;
}

interface SwitchBtnProps {
    defaultSelect: string;
    options: Option[];
    onSwitched: (value: string) => void;
}
const SwitchBtn: React.FC<SwitchBtnProps> = ({ defaultSelect, options, onSwitched }) => {
    const moduleName = 'switchBtn';
    const defaultOption = options.filter((item) => item.value !== defaultSelect);
    const [selected, setSelected] = React.useState<Option>(defaultOption[0]);
    const anotherOption = options.filter((item) => item.value !== selected.value);
    return (
        <div
            className={styles[`${moduleName}`]}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => {
                setSelected(anotherOption[0]);
                onSwitched(selected.value);
            }}
        >
            <span className={styles[`${moduleName}_text`]} onMouseDown={(e) => e.preventDefault()}>
                {selected.text}
            </span>
        </div>
    );
};

export default SwitchBtn;
